import React from "react";
import slide from "../../../assets/Image/card1.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/modules";
import { Navigation, Pagination } from "swiper/modules";
import { IoIosInformationCircleOutline } from "react-icons/io";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const MarketCard = () => {
  const images = [slide, slide, slide, slide, slide];

  return (
    <div className="my-10 flex flex-col justify-center items-center">
      <Swiper
        className="my-4 w-40 bg-slate-200 flex justify-center items-center z-0 sticky"
        modules={[Navigation, Pagination]}
        navigation
        spaceBetween={50}
        slidesPerView={1}
        onSlideChange={() => console.log("slide change")}
        onSwiper={(swiper) => console.log(swiper)}
      >
        {images.map((image) => (
          <SwiperSlide
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingTop: "10px",
              paddingBottom: "10px"
            }}
          >
            <img src={image} alt="" />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="w-40">
        <div className="flex items-center justify-between">
          <p>6/12 R</p>
          <IoIosInformationCircleOutline className="w-6 h-auto"/>
        </div>
        <p>Dark gurito</p>
        <p className="font-extrabold text-2xl">$2.99</p>
        <p>Profit: <span className="font-extrabold text-green-700">+$3.22</span></p>
        <p>Worth: +$3.22</p>

        <div className="flex justify-between items-center">
          <img src="https://icons8.com/icon/31079/ebay" alt="" />
          <p className="font-extrabold">4:20:30s</p>
        </div>
      </div>
    </div>
  );
};

export default MarketCard;
